import { createSlice } from '@reduxjs/toolkit';
import { SEARCH_REQUEST_TYPES } from '../shared/searchRequestTypes';
import { createSearchFieldMaps, appendSearchFieldReducers } from './createSearchSliceHelpers';

const fieldMaps = createSearchFieldMaps(SEARCH_REQUEST_TYPES);

const initialState = {
  results: { ...fieldMaps.results },
  loading: { ...fieldMaps.loading },
  error: { ...fieldMaps.error },
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    ...(() => {
      const reducers = {};
      appendSearchFieldReducers(reducers, SEARCH_REQUEST_TYPES);
      return reducers;
    })(),
  },
});

export const {
  clearSearchResults,
  setLoadingForType,
  setResultsForType,
  setErrorForType,
} = searchSlice.actions;

export default searchSlice.reducer;
